import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useGuardedNavigation } from '../../../permissions/useGuardedNavigation';
import { usePermissions } from '../../../permissions/usePermissions';

const OrganizationActionMenu = ({ organization, onProvisionTIN, showProvisionTIN = false }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { navigateDetails, navigateEdit } = useGuardedNavigation('organizations');
  const { canCreate } = usePermissions();

  const onClickingDetails = () => {
    handleClose();
    navigateDetails(organization.stripe_customer_id);
  };

  const onClickingEdit = () => {
    handleClose();
    navigateEdit(organization.stripe_customer_id);
  };

  const onClickingProvisionTIN = () => {
    handleClose();
    onProvisionTIN?.(organization);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton data-testid="action-icon-button" onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              boxShadow: '4px 4px 10px 0px rgba(0,0,0,0.2)',
            },
          },
        }}
      >
        <MenuItem data-testid="details" key="details" onClick={onClickingDetails}>
          Details
        </MenuItem>
        <MenuItem data-testid="edit" key="edit" onClick={onClickingEdit}>
          Edit
        </MenuItem>
        {showProvisionTIN ? (
          <MenuItem
            data-testid="provision-tin"
            key="provision-tin"
            disabled={!canCreate('organizations')}
            onClick={onClickingProvisionTIN}
          >
            Provision TIN
          </MenuItem>
        ) : null}
      </Menu>
    </>
  );
};

export default OrganizationActionMenu;
